export default "__VITE_ASSET__C1mJAWJs__"